// 배열 순서 = 화면 노출 순서. 취득일이 아니라 중요도 기준으로 정렬한다.
const certifications = [
  {
    id: 8,
    name: "정보처리기사",
    organization: "한국산업인력공단",
    date: "2025년 9월",
    number: "2500202****",
    category: "Software",
  },
  {
    id: 7,
    name: "빅데이터분석기사",
    organization: "한국데이터산업진흥원",
    date: "2025년 7월",
    number: "BAE-01000****",
    category: "Big Data",
  },
  {
    id: 4,
    name: "SQL 개발자 (SQLD)",
    organization: "한국데이터산업진흥원",
    date: "2024년 9월",
    number: "SQLD-05400****",
    category: "Database",
  },
  {
    id: 6,
    name: "데이터분석준전문가 (ADsP)",
    organization: "한국데이터산업진흥원",
    date: "2025년 6월",
    number: "ADsP-04500****",
    category: "Data Analysis",
  },
  {
    id: 9,
    name: "리눅스 마스터 2급",
    organization: "한국정보통신진흥협회",
    date: "2025년 10월",
    number: "LMS-2503-00****",
    category: "System",
  },
  {
    id: 5,
    name: "정보처리산업기사",
    organization: "한국산업인력공단",
    date: "2024년 12월",
    number: "0105****",
    category: "Software",
  },
  {
    id: 2,
    name: "ITQ 한글엑셀 · 한글파워포인트",
    organization: "한국생산성본부",
    date: "2019년 6월",
    number: "A001-2019255-00****",
    category: "Office",
  },
  {
    id: 1,
    name: "전산회계 2급",
    organization: "한국세무사회",
    date: "2017년 9월",
    number: "220731****",
    category: "Accounting",
  },
];

export const CERT_GROUPS = {
  Software: ["Software"],
  Data: ["Database", "Data Analysis", "Big Data"],
  Others: ["Office", "System", "Accounting"],
};

export default certifications;
